import React from "react"

const legacyMapProps = {
  detail_row: "detailId",
  teaser_id: "teaserId",
  panel_style: "teaserStyle",
  teaser_style: "teaserStyle",
  button_style: "buttonStyle",
  button_text: "buttonText",
}

const mapLegacyProps = props =>
  Object.entries(props)
    .map(([key, val]) => {
      if (legacyMapProps.hasOwnProperty(key)) {
        key = legacyMapProps[key]
      }
      return [key, val]
    })
    .reduce(
      (agg, [key, val]) => ({
        ...agg,
        [key]: val,
      }),
      {}
    )

export default Component => props => <Component {...mapLegacyProps(props)} />
